import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { IDataProspecto } from "../interfaces"
import { EstadoComponente, ModalObservacionComponente } from "../components/ui"
import { calcColorStatusGeneral, cellLineaRazonSocial, cellNotFilter, emptyCell, emptyCellOneLevel, formatDateWithTimeAMPM } from "../utils"
import { SEGMENTACION_CHOICE, SI_NO_CHOICE, TIPO_IDENTIFICACIONES_CHOICE, EstadoProspectoEnum } from "../constants"
import InfoUser from "../components/ui/InfoUser/InfoUser"
import { Button } from "@mui/material"
import { openGenericObjectModal } from "../components/ui/ModalGenericObject/useGenericObjectModalStore"
import { fieldsEquifax } from "../utils/fields-modal-generic-object"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface useTableColumnsProspectoProps {
  estado_prospecto: EstadoProspectoEnum;
}

export const useTableColumnsProspecto = ({

}: useTableColumnsProspectoProps) => {


  const columnsBase = useMemo<MRT_ColumnDef<IDataProspecto>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 300,
      disableSortBy: true,
      Cell: ({ row }) => cellLineaRazonSocial(null, row.original?.razon_social, row.original.linea!)
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
    },
    {
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'linea',
      header: 'Servicio',
      size: 200,
      Cell: ({ row }) => (
        row.original.linea != null ? `S${row.original.linea}` : 'N/A'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_prospecto',
      header: 'Estado',
      size: 150,
      Cell: ({ row }) => (
        row.original.estado_prospecto != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_prospecto)}
            texto={row.original.estado_prospecto} /> : null
      ),
    },
    {
      accessorKey: 'motivo_rechazo',
      header: 'Motivo Rechazo',
      size: 200,
      Cell: ({ row }) => (
        emptyCell(row.original.motivo_rechazo_data?.nombre)
      )
    },
    {
      accessorKey: 'observacion_cancelar',
      header: 'Observación cancelar',
      size: 200,
      Cell: ({ row }) => (
        emptyCell(row.original.observaciones?.observacion_cancelar)
      )
    },
    {
      accessorKey: 'es_discapacitado',
      header: 'Discapacidad',
      filterVariant: 'select',
      filterSelectOptions: SI_NO_CHOICE,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      size: 20,
      Cell: ({ row }) => (row.original.es_discapacitado ? 'SI' : 'NO'),
    },
    {
      accessorKey: 'es_tercera_edad',
      header: 'Tercera Edad',
      filterVariant: 'select',
      filterSelectOptions: SI_NO_CHOICE,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      size: 20,
      Cell: ({ row }) => (
        row.original.es_tercera_edad ? <span>SI</span> : <span>NO</span>
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'pais_data.nacionalidad',
      header: 'Nacionalidad',
      size: 20,
      Cell: ({ row }) => (
        row.original.pais_data ?
          emptyCell(row.original.pais_data.nacionalidad)
          : 'N/A'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'pais_data.nombre',
      header: 'País',
      size: 20,
      Cell: ({ row }) => (
        row.original.pais_data ?
          emptyCell(row.original.pais_data.nombre)
          : 'N/A'
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_nacimiento',
      header: 'Fecha Nacimiento',
      Cell: ({ row }) => (
        emptyCell(row.original.fecha_nacimiento)
      )
    },
    {
      accessorKey: 'edad',
      header: 'Edad',
      size: 20,
      Cell: ({ row }) => (
        row.original.edad != null ? row.original.edad.toString() : 'N/A'
      )
    },
    {
      accessorKey: 'celular',
      header: 'Celular',
      size: 200,
    },

    //RUC
    {
      ...cellNotFilter,
      accessorKey: 'tipo_contribuyente',
      header: 'tipo contribuyente',
      size: 200,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original, 'tipo_contribuyente')
      )
    },
    {
      accessorKey: 'estado_contribuyente_ruc',
      header: 'Estado Contribuyente RUC',
      size: 200,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original, 'estado_contribuyente_ruc')
      )
    },
    {
      accessorKey: 'regimen',
      header: 'regimen',
      size: 200,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original, 'regimen')
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'actividad_economica_principal',
      header: 'actividad econmica',
      size: 200,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original, 'actividad_economica_principal')
      )
    },

    //BURO CREDITO
    {
      accessorKey: 'equifax',
      header: 'Equifax',
      size: 200,
      Cell: ({ row }) => {
        return <Button
          startIcon={<OpenInNewIcon />}
          onClick={() => {
            openGenericObjectModal({
              data: row.original,
              fields: fieldsEquifax,
              title: "Información",
              emptyFallback: "—",
            });
          }}
        >VER</Button>
      }
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
      size: 200
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 200,
      Cell: ({ row }) => (
        <InfoUser user={row.original.user_create ?? 'N/A'} />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
  ], [])


  const columnsBaseCorporativo = useMemo<MRT_ColumnDef<IDataProspecto>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 300,
      disableSortBy: true,
      Cell: ({ row }) => (
        `${row.original?.razon_social} ${row.original.linea != 1 ? `- LINEA ${row.original.linea}` : ''}` || 'N/A'
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
    },
    {
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha Solicitud',
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    /* {
      ...cellNotFilter,
      accessorKey: 'fecha_modificacion',
      header: 'Fecha de Cancelacion',
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_modificacion)
      ),
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'estado_prospecto',
      header: 'Estado',
      Cell: ({ row }) => (
        row.original.estado_prospecto != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_prospecto)}
            texto={row.original.estado_prospecto} /> : null
      ),
    },

    {
      accessorKey: 'celular',
      header: 'Celular',
    },

    //RUC
    {
      ...cellNotFilter,
      accessorKey: 'tipo_contribuyente',
      header: 'tipo contribuyente'
    },
    {
      accessorKey: 'estado_contribuyente_ruc',
      header: 'Estado Contribuyente RUC',
      Cell: ({ row }) => (
        emptyCell(row.original.estado_contribuyente_ruc)
      )
    },
    {
      accessorKey: 'regimen',
      header: 'regimen',
      Cell: ({ row }) => (
        emptyCell(row.original.regimen)
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'actividad_economica_principal',
      header: 'actividad econmica',
      size: 300,
      Cell: ({ row }) => (
        row.original.actividad_economica_principal ?
          <ModalObservacionComponente observacion_cliente={row.original.actividad_economica_principal} /> : 'N/A'
      )
    },

    //BURO CREDITO
    {
      filterVariant: 'select',
      filterSelectOptions: SEGMENTACION_CHOICE,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      accessorKey: 'segmentacion',
      header: 'Segmentacion',
    },
    {
      accessorKey: 'puntaje_score_empresa',
      header: 'Puntaje Empresa',
    },
    {
      accessorKey: 'puntaje_score',
      header: 'Puntaje Score',
    },
    {
      accessorKey: 'puntaje_score_sobreendeudamiento',
      header: 'Puntaje Score Sobreendeudamiento',
    },
    {
      accessorKey: 'vendedor_nombre',
      header: 'Nombre Asesor',
      size: 300,
      Cell: ({ row }) => row.original?.vendedor_data?.razon_social || "N/A"
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Asesor',
      Cell: ({ row }) => (
        <InfoUser user={row?.original?.user_create!} />
      )
    },
  ], [])

  const columnsBaseCorporativoFallido = useMemo<MRT_ColumnDef<IDataProspecto>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 300,
      disableSortBy: true,
      Cell: ({ row }) => (
        `${row.original?.razon_social} ${row.original.linea != 1 ? `- LINEA ${row.original.linea}` : ''}` || 'N/A'
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
    },
    {
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha Solicitud',
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_modificacion',
      header: 'Fecha de Cancelacion',
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_modificacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_prospecto',
      header: 'Estado',
      Cell: ({ row }) => (
        row.original.estado_prospecto != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_prospecto)}
            texto={row.original.estado_prospecto} /> : null
      ),
    },

    {
      accessorKey: 'celular',
      header: 'Celular',
    },

    //RUC
    {
      ...cellNotFilter,
      accessorKey: 'tipo_contribuyente',
      header: 'tipo contribuyente'
    },
    {
      accessorKey: 'estado_contribuyente_ruc',
      header: 'Estado Contribuyente RUC',
      Cell: ({ row }) => (
        emptyCell(row.original.estado_contribuyente_ruc)
      )
    },
    {
      accessorKey: 'regimen',
      header: 'regimen',
      Cell: ({ row }) => (
        emptyCell(row.original.regimen)
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'actividad_economica_principal',
      header: 'actividad econmica',
      size: 300,
      Cell: ({ row }) => (
        row.original.actividad_economica_principal ?
          <ModalObservacionComponente observacion_cliente={row.original.actividad_economica_principal} /> : 'N/A'
      )
    },

    //BURO CREDITO
    {
      filterVariant: 'select',
      filterSelectOptions: SEGMENTACION_CHOICE,
      muiTableHeadCellFilterTextFieldProps: {
        select: true,
      },
      accessorKey: 'segmentacion',
      header: 'Segmentacion',
    },
    {
      accessorKey: 'puntaje_score_empresa',
      header: 'Puntaje Empresa',
    },
    {
      accessorKey: 'puntaje_score',
      header: 'Puntaje Score',
    },
    {
      accessorKey: 'puntaje_score_sobreendeudamiento',
      header: 'Puntaje Score Sobreendeudamiento',
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
    },
    {
      accessorKey: 'vendedor_nombre',
      header: 'Nombre Asesor',
      size: 300,
      Cell: ({ row }) => row.original?.vendedor_data?.razon_social || "N/A"
    },
    {
      accessorKey: 'user_create',
      header: 'Usuario Asesor',
      Cell: ({ row }) => (
        <InfoUser user={row?.original?.user_create!} />
      )
    },
  ], [])

  return {
    columnsBase,
    columnsBaseCorporativo,
    columnsBaseCorporativoFallido
  }
}